<svg class="icons">
  <g
    *ngFor="let icon of icons.all"
    [id]="icon.id"
    [innerHTML]="getTrustedHtml(icon.svg)"
  ></g>
</svg>
